import React from "react";

import {
  Modal,
  Input,
  Button,
  Select,
  Form,
  Popconfirm,
  Row,
  Col,
  Typography,
  Tag,
  Tooltip,
} from "antd";

import { StopOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

import { useState, useEffect } from "react";

import {
  GetSchools,
  AddRaceResults,
  GetDisqualifications,
} from "../../APIManager";

import styles from "./ChooseRaceResults.module.css";

import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from "react-beautiful-dnd";

const { Text } = Typography;

export default function ChooseRaceResultsModalWithTime({
  modalVisible,
  onCloseModal,
  OnSubmit,
  race,
  schools,
  isReadOnly,
}) {
  const [raceOrder, SetRaceOrder] = useState([]);

  const [disqualifications, SetDisqualifications] = useState([]);
  const [dataFetched, SetDataFetched] = useState(false);

  const [form] = Form.useForm();

  useEffect(() => {
    GetDisqualifications().then((res) => {
      SetDisqualifications(res.data);
      SetDataFetched(true);
    });
  }, []);

  useEffect(() => {
    if (race?.RaceResults?.length > 0) {
      SetRaceOrder(race.RaceResults);
    }

    // Pre-fill form with existing race times if available
    if (modalVisible && race?.RaceTimes) {
      form.setFieldsValue({ times: race.RaceTimes });
    }

    // Reset form when modal closes
    if (!modalVisible) {
      form.resetFields();
    }
  }, [race, modalVisible, form]);

  useEffect(() => {
    if (!race || schools.length < 1) {
      return;
    }

    if (race.RaceResults.length > 0) {
      const RaceResults = global
        .structuredClone(race.RaceResults)
        .map((p) => GetSchoolInfo(p));

      console.log(RaceResults);

      RaceResults.forEach((p, index) => {
        const dq = disqualifications.filter(
          (d) => d.RaceName == race.RaceName && d.School._id == p._id,
        )[0];

        if (dq) {
          RaceResults[index].dq = dq;
        }
        var isDisqualified = race.Participants.filter(
          (pp) => pp.school == p._id,
        )[0].isDisqualified;

        RaceResults[index].isDisqualified = isDisqualified;
      });

      SetRaceOrder(RaceResults);
    } else {
      const RaceDetails = global.structuredClone(race);

      RaceDetails.Participants.forEach((p, index) => {
        if (p.isPlaceHolder) {
          return;
        } else {
          RaceDetails.Participants[index].school = GetSchoolInfo(p.school);
          const dq = disqualifications.filter(
            (d) => d.RaceName == race.RaceName && d.School._id == p.school._id,
          )[0];

          if (dq) {
            RaceDetails.Participants[index].school.dq = dq;
          } else {
            RaceDetails.Participants[index].school.dq = null;
          }
          if (RaceDetails.Participants[index].isDisqualified) {
            RaceDetails.Participants[index].school.isDisqualified = true;
          } else {
            RaceDetails.Participants[index].school.isDisqualified = false;
          }
        }
      });

      // Sorting logic
      console.log(RaceDetails.Participants);
      RaceDetails.Participants.sort((a, b) => {
        // Check if DQ property exists in each object

        if (a.isPlaceHolder || b.isPlaceHolder) {
          return 0;
        }

        const hasDQA = a.school.dq || a.isDisqualified;
        const hasDQB = b.school.dq || b.isDisqualified;

        console.log(hasDQA);
        console.log(hasDQB);

        // Compare based on the presence of DQ property
        if (hasDQA && !hasDQB) {
          console.log("brrrrrrrrrrrrrrrrrrr");
          return 1; // If 'a' has DQ but 'b' doesn't, 'a' comes after 'b'
        } else if (!hasDQA && hasDQB) {
          return -1; // If 'b' has DQ but 'a' doesn't, 'b' comes after 'a'
        } else {
          return 0; // If both have DQ or neither have DQ, maintain their order
        }
      });
      SetRaceOrder(RaceDetails.Participants.map((p) => p.school));
    }
  }, [schools, race, modalVisible, disqualifications]);

  function GetSchoolInfo(id) {
    return schools.filter((s) => s._id == id)[0];
  }

  if (!race) {
    return <></>;
  }

  function onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      raceOrder,
      result.source.index,
      result.destination.index,
    );

    SetRaceOrder(items);
  }

  const resultsSet = race?.RaceResults?.length > 1;

  console.log({ raceOrder });

  return (
    <div>
      <Modal
        title={`${resultsSet ? "Update" : "Add"} race results for ${
          race.RaceName
        }`}
        forceRender
        visible={modalVisible}
        onOk={() => {
          //OnSubmit(selectedDay);
        }}
        onCancel={onCloseModal}
        okText="Confirm Results"
        cancelText="Cancel"
        width="600px"
        okButtonProps={{
          hidden: true,
        }}
        // cancelButtonProps={{ hidden: true }}
        maskClosable={false}
      >
        {isReadOnly && resultsSet < 1 && <div>Race Results are awaited</div>}
        <div hidden={isReadOnly && resultsSet < 1}>
          <Form
            form={form}
            layout="vertical"
            name="race_time_entry"
            initialValues={{}} // Set initial times here if editing
          >
            {raceOrder.map((entry, index) => {
              // Access the DQ property
              const dqData = entry.dq;
              const isDq = !!dqData;

              // Hide disqualified entries from the form (they're already sorted at the end)
              if (entry.isDisqualified) {
                return null;
              }

              // Helper function to get ordinal suffix
              const getOrdinal = (n) => {
                const s = ["th", "st", "nd", "rd"];
                const v = n % 100;
                return n + (s[(v - 20) % 10] || s[v] || s[0]);
              };

              // Calculate position excluding disqualified entries
              const nonDqIndex = raceOrder
                .slice(0, index)
                .filter((e) => !e.isDisqualified && !e.dq).length;

              return (
                <div
                  key={entry._id || index}
                  style={{
                    marginBottom: 16,
                    borderBottom: "1px solid #f0f0f0",
                    paddingBottom: 12,
                  }}
                >
                  <Row align="middle" gutter={[16, 16]}>
                    {/* School Name Column */}
                    <Col span={12}>
                      <Text strong style={{ fontSize: "16px" }}>
                        {resultsSet && !isDq && !entry.isDisqualified && (
                          <Tag color="blue" style={{ marginRight: 8 }}>
                            {getOrdinal(nonDqIndex + 1)}
                          </Tag>
                        )}
                        {entry.schoolname || "Unknown School"}
                      </Text>
                    </Col>

                    {/* Time Input or DQ Status Column */}
                    <Col span={12}>
                      {isDq ? (
                        // DQ Display
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {/* Short Type Display */}
                          <Tag
                            color="error"
                            style={{ fontSize: "14px", padding: "4px 10px" }}
                          >
                            {dqData.ShortType}
                          </Tag>

                          {/* Tooltip with Details */}
                          <Tooltip
                            title={
                              <div style={{ fontSize: "12px" }}>
                                <div>
                                  <strong>Type:</strong> {dqData.Type}
                                </div>
                                <div>
                                  <strong>Reason:</strong> {dqData.Reason}
                                </div>
                                <div>
                                  <strong>Signed By:</strong> {dqData.SignedBy}
                                </div>
                              </div>
                            }
                          >
                            <ExclamationCircleOutlined
                              style={{
                                color: "#faad14",
                                cursor: "help",
                                fontSize: "16px",
                              }}
                            />
                          </Tooltip>

                          {/* Optional: Visual indicator that input is blocked */}
                          <Text
                            type="secondary"
                            style={{ fontSize: "12px", marginLeft: "auto" }}
                          >
                            No time entry allowed
                          </Text>
                        </div>
                      ) : (
                        // Active Time Input
                        <Form.Item
                          // Naming the field by School ID ensures unique values in the form object
                          name={["times", entry._id]}
                          style={{ margin: 0 }}
                          rules={[
                            { required: true, message: "Please enter a time" },
                            {
                              pattern: /^\d{2}:\d{2}\.\d{3}$/,
                              message: "Time must be in format mm:ss.ms (e.g., 00:57.814)",
                            },
                          ]}
                        >
                          <Input
                            placeholder="00:57.814"
                            style={{ width: "100%" }}
                            size="middle"
                            disabled={isReadOnly}
                          />
                        </Form.Item>
                      )}
                    </Col>
                  </Row>
                </div>
              );
            })}
          </Form>
        </div>
        <Popconfirm
          placement="bottomLeft"
          title={
            "Are you sure you want to add these race results. This action cannot be undone"
          }
          onConfirm={() => {
            form
              .validateFields()
              .then((values) => {
                const times = values.times || {};

                // Helper function to convert time string to milliseconds for comparison
                const timeToMs = (timeStr) => {
                  if (!timeStr) return Infinity;
                  const match = timeStr.match(/^(\d{2}):(\d{2})\.(\d{3})$/);
                  if (!match) return Infinity;
                  const [, minutes, seconds, ms] = match;
                  return parseInt(minutes) * 60000 + parseInt(seconds) * 1000 + parseInt(ms);
                };

                // Sort raceOrder by times, with DQs at the end
                const sortedRaceOrder = [...raceOrder].sort((a, b) => {
                  const isDqA = a.dq || a.isDisqualified;
                  const isDqB = b.dq || b.isDisqualified;

                  // DQs go to the end
                  if (isDqA && !isDqB) return 1;
                  if (!isDqA && isDqB) return -1;
                  if (isDqA && isDqB) return 0;

                  // Both are not DQ, sort by time
                  const timeA = timeToMs(times[a._id]);
                  const timeB = timeToMs(times[b._id]);
                  return timeA - timeB;
                });

                AddRaceResults({
                  raceName: race.RaceName,
                  raceResults: sortedRaceOrder.map((r) => r._id),
                  raceTimes: times,
                }).then(() => {
                  OnSubmit();
                });
              })
              .catch((errorInfo) => {
                console.log("Validation failed:", errorInfo);
              });
          }}
          okText="Yes"
          cancelText="No"
        >
          <Button disabled={isReadOnly} hidden={isReadOnly} type="primary">
            {resultsSet ? "Update Results" : "Add Results"}
          </Button>
        </Popconfirm>
      </Modal>
    </div>
  );
}

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  result.sort((a, b) => {
    var DQA = a.dq || a.isDisqualified;
    var DQB = b.dq || b.isDisqualified;

    if (DQA && !DQB) {
      return 1; // If 'a' has DQ but 'b' doesn't, 'a' comes after 'b'
    } else if (!DQA && DQB) {
      return -1; // If 'b' has DQ but 'a' doesn't, 'b' comes after 'a'
    } else {
      return 0; // If both have DQ or neither have DQ, maintain their order
    }
  });

  return result;
};
